import './frontend/hot.js';
import 'whatwg-fetch';
import { createRoot } from 'react-dom/client';
import { AG_GRID_LICENSE } from './frontend/injectedConstants.js';
import { getSentryClient } from './frontend/sentry.js';
import { getAccessToken } from './frontend/relay.js';
import { getKeycloakClient } from './frontend/keycloak.js';

const container = document.getElementById('root');

if (container) {
  // eslint-disable-next-line @typescript-eslint/await-thenable
  Promise.all([getKeycloakClient(), getSentryClient()])
    .then(async () => {
      return getAccessToken();
    })
    .then((token) => {
      if (token == null) {
        throw new Error('Token is null');
      }
      return Promise.all([
        import('ag-grid-community'),
        import('ag-grid-enterprise'),
        import('react'),
        import('./frontend/i18n.js'),
      ]);
    })
    .then(async ([agGridCommunity, agGridEnterprise, react, i18n]) => {
      // Register all community and enterprise features
      // It must be registered before importing the render function
      agGridCommunity.ModuleRegistry.registerModules([
        agGridCommunity.AllCommunityModule,
        agGridEnterprise.AllEnterpriseModule,
      ]);

      if (AG_GRID_LICENSE != null && AG_GRID_LICENSE.trim() !== '') {
        agGridEnterprise.LicenseManager.setLicenseKey(AG_GRID_LICENSE);
      }
      // eslint-disable-next-line @typescript-eslint/await-thenable
      return Promise.all([react, i18n.initI18n()]);
    })
    .then(async ([react]) => {
      return react.lazy(async () => {
        return import('./frontend/AppWrapper.js');
      });
    })
    .then((AppWrapper) => {
      const root = createRoot(container);
      root.render(<AppWrapper />);
    })
    .catch((error) => {
      getSentryClient()?.captureException(error);
    });
}
